import React from 'react'
import styles from './PublishComponent.scss'
import { rawElementFactory } from '../commons/editor/EditorFactory'

const createHtml = ( content, scaleFactor = 1 ) => {
  return { __html: rawElementFactory( content, scaleFactor, true ) }
}

const SingleRender = ( { singlePage, scaleFactor } ) => {
  return (
    <React.Fragment>
      {singlePage.items.map( ( { content }, itemIndex ) => {
        content = JSON.parse( content )
        return (
          <div
            key={itemIndex}
            dangerouslySetInnerHTML={createHtml( content, scaleFactor )}
          />
        )
      } )}
    </React.Fragment>
  )
}

export const RenderPages = props => {
  const { pages, singlePage, scaleFactor, start } = props

  return (
    <React.Fragment>
      {singlePage ? (
        <SingleRender {...props} />
      ) : (
        <React.Fragment>
          {pages.map( ( page, pageIndex ) => {
            const style = JSON.parse( page.properties ) || {
              backgroundColor: '#fff'
            }
            return (  
              <div key={page.id} className={styles.page} style={style}>     
                {pageIndex % 2 === 0 ? (
                  <div className={styles['gradients-odd']} />
                ) : (
                  <div className={styles['gradients-even']} />
                )}
                {start &&
                  <React.Fragment>
                    {page.items.map(({ content }, itemIndex) => {
                      content = JSON.parse(content)
                      return (
                        <div
                          key={itemIndex}
                          dangerouslySetInnerHTML={createHtml(content, scaleFactor)}
                        />
                      )
                    })}
                  </React.Fragment>
                }
              </div>
            )
          } )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/publish/RenderPages.js